import React, { useEffect, useState } from 'react'
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import swal from 'sweetalert';
import { TypeAnimation } from 'react-type-animation';
import jopay from '../music/crazier.mp3';
import ReactPlayer from 'react-player';
import Landing from './Landing';


function FrontPage() {

    const [visible, setVisible] = useState(false)
    const [loading, setloading] = useState(true)
    const [isPlaying, setIsPlaying] = useState(false);
    const [passworddata, setpassword] = useState({
        password: "",
    });

    const handleinput = (e) => {
        e.persist();
        setpassword({ ...passworddata, [e.target.name]: e.target.value });
    }

    useEffect(() => {
        setVisible(true)
    }, []);

    const SubmitCode = (e) => {
        e.preventDefault();

        const data = {
            password: passworddata.password,
        }

        if (data.password === "09210000") {
            setVisible(false)
            setloading(false)
            setIsPlaying(true)
            localStorage.setItem('auth_token', 'OPEN');
        }
        else {
            swal("Warning", "Error Pin", 'warning');
            document.getElementById('pin').reset();
        }

    }

    


    return (
        <>
            <Dialog header="Enter 8 Pin" position='top' draggable={false} visible={visible} onHide={() => setVisible(false)}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <div className="container">
                    <form onSubmit={SubmitCode} id='pin'>
                        <div className="row">
                            <div className="col-lg-12">
                                <label htmlFor="" className="form-label">
                                    PIN
                                </label>
                                <InputText type='password' maxLength={8} keyfilter={'pint'} onChange={handleinput} name='password' className='w-100 p-inputtext-sm' />
                            </div>
                            <div className="mt-3">
                                <Button className='p-button-sm p-button-info --p-button-info' label="Enter" />
                            </div>
                        </div>
                    </form>
                </div>
            </Dialog>

            <Landing />



            {
                loading ? "" :
                    <>
                        
                        <div className="container">
                            <ReactPlayer
                                url={jopay}
                                playing={isPlaying}
                                width="300px"
                                height="50px"
                                loop={true}
                                volume={1}
                            />
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                                    <Card className='bg-transparent'>
                                        <TypeAnimation
                                            sequence={[
                                                `Dear Madam Flower,
                                                
                                            \nFirst of all, Happy Valentine's Day in advance! I'm giving this to you early since  work from home bukas hehehehe 😄. Thank you, Madam Flower Mary, for your presence, your beautiful smile, and your support. I truly appreciate having you around 😘😘. I just wanted to take a moment to remind you how much you mean to me. Valentine's Day isn't just about romantic love it's also about appreciating the wonderful people in our lives.
                                            \n \n So, on this special day, I hope you smile a little brighter, laugh a little louder, and feel just how loved and cherished you truly are. You are amazing, and I'm so lucky to have you. 😘  
                                           
                                            \nSincerely yours,

                                            Georgie 😚`
                                            ]}


                                            wrapper="p"
                                            speed={30}
                                            style={{ whiteSpace: 'pre-line', fontSize: '9px', display: 'inline-block', color: 'white' }}
                                        />
                                    </Card>

                                </div>
                            </div>
                        </div>
                    </>
            }
        </>
    )
}

export default FrontPage
